/**
 * An add-on listed from its stored record alone is missing the fields only the
 * catalog supplies. There are two reasons for that, and they need different
 * words: the catalog could not be loaded, which resolves on its own, or the
 * catalog loaded and does not list this add-on, which will not.
 */
const LAUNCH_CATALOG_UNAVAILABLE =
  'The add-on catalog could not be loaded, so there is no route to open this add-on. It will work again once the catalog loads.';
const LAUNCH_NOT_IN_CATALOG =
  'This add-on is not listed in the current add-on catalog, so there is no route to open it.';

const INSTALL_CATALOG_UNAVAILABLE =
  'The add-on catalog could not be loaded, so the chart to install from is unknown. It will be installable again once the catalog loads.';
const INSTALL_NOT_IN_CATALOG =
  'This add-on is not listed in the current add-on catalog, so the chart to install from is unknown.';

export const PORTAINER_UPGRADE_REQUIRED_TO_INSTALL =
  'Every version of this add-on needs a newer version of Portainer. Upgrade Portainer to install it.';
export const PORTAINER_UPGRADE_REQUIRED_TO_CHANGE_VERSION =
  'Every published version of this add-on needs a newer version of Portainer. Upgrade Portainer to change its version.';
/** Label for the greyed-out upgrade action. */
export function portainerUpgradeRequiredLabel(version: string) {
  return `v${version} needs a newer Portainer`;
}

export function portainerUpgradeRequiredMessage(version: string) {
  return `Version ${version} of this add-on needs a newer version of Portainer. Upgrade Portainer to upgrade the add-on.`;
}

export function launchBlockedMessage(catalogUnavailable: boolean) {
  return catalogUnavailable
    ? LAUNCH_CATALOG_UNAVAILABLE
    : LAUNCH_NOT_IN_CATALOG;
}

export function installBlockedMessage(catalogUnavailable: boolean) {
  return catalogUnavailable
    ? INSTALL_CATALOG_UNAVAILABLE
    : INSTALL_NOT_IN_CATALOG;
}
